import React, { useState } from 'react';
import { TextField, Button, Typography, Container, Paper, IconButton } from '@mui/material';
import emailjs from 'emailjs-com';

import { useNavigate } from 'react-router-dom';
import CloseIcon from '@mui/icons-material/Close';


const FeedbackPage = () => {
    const [message, setMessage] = useState('');
    const [status, setStatus] = useState('');
    const navigate = useNavigate();

    const handleSubmit = (e) => {
        e.preventDefault();

        // Use EmailJS to send the message
        emailjs.send(
            'serv_SewerTycoonDetroit', // EmailJS service ID
            'template_bnv7ax8', // EmailJS template ID (from Email Tempate tab)
            { message, title: 'SewerTycoon Detroit Application Feedback' },
            'oH7oHiZnEgJer7b6j' // EmailJS public key (from Account tab)
        )
        .then(() => {
            setStatus('Feedback sent successfully!');
            setMessage('');
        })
        .catch(() => {
            setStatus('Failed to send feedback. Please try again.');
        });
    };

    const handleReturn = () => {
        navigate('/'); // Navigate to the main page
    };

    return (
        <Container
            maxWidth="sm"
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100vh', 
                width: '100vw',
                backgroundColor: '#121212',
                color: '#ffffff',
                borderRadius: 2,
            }}
        >
            <Paper
                elevation={3}
                sx={{
                    position: 'relative',
                    padding: 4,
                    textAlign: 'center',
                    borderRadius: 2,
                    backgroundColor: '#1e1e1e',
                    height: '80%',
                    width: '100%'
                }}
            >
                <IconButton
                    onClick={handleReturn}
                    sx={{
                        position: 'absolute',
                        top: 16,
                        right: 16,
                        color: '#ffffff',
                    }}
                >
                    <CloseIcon />
                </IconButton>

                <Typography variant="h5" sx={{ marginBottom: 10, fontWeight: 'bold', color: '#90caf9' }}>
                    Send Us Your Feedback
                </Typography>
                <form onSubmit={handleSubmit}>
                    <TextField
                        placeholder="Your Feedback"
                        variant="outlined"
                        multiline
                        rows={12}
                        fullWidth
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                        sx={{
                            marginBottom: 2,
                            backgroundColor: '#ffffff',
                            borderRadius: 1,
                        }}
                        InputProps={{
                            style: { color: '#000000' }, // Sets the text color to black
                        }}
                        InputLabelProps={{
                            style: { color: '#757575' }, // Optional: Adjust label color for contrast
                        }}
                    />
                    <Button
                        variant="contained"
                        type="submit"
                        fullWidth
                        sx={{
                            backgroundColor: '#1e88e5',
                            color: '#ffffff',
                            '&:hover': { backgroundColor: '#1565c0' },
                        }}
                    >
                        Submit
                    </Button>
                </form>
                {status && (
                    <Typography
                        variant="body2"
                        sx={{
                            marginTop: 2,
                            color: status.includes('successfully') ? '#4caf50' : '#f44336',
                        }}
                    >
                        {status}
                    </Typography>
                )}
            </Paper>
        </Container>
    );
};

export default FeedbackPage;